import React from 'react';
import Error, { ErrorProps } from './Error';
import './styles/FullScreenError.css';

const FullScreenError: React.FC<ErrorProps> = ({
	message = 'Произошла ошибка при загрузке данных.',
	onRetry,
}) => {
	return (
		<div className="fullscreen-error">
			<div className="glass-ui">
				<Error message={message} onRetry={onRetry} />
			</div>
		</div>
	);
};

export default FullScreenError;